import { render, staticRenderFns } from "./ResearchOutputAbstractModal.vue?vue&type=template&id=4fa041f0&"
import script from "./ResearchOutputAbstractModal.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputAbstractModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports